import { createContext, useContext } from 'react';

// Opens Ask Gargi with a question and what the person was looking at. `available` is false outside the Gargi
// page's provider, so shared components only offer Ask Gargi where it can open.
export interface GargiContextValue {
  open: (question?: string, context?: Record<string, unknown>) => void;
  available: boolean;
}

export const GargiContext = createContext<GargiContextValue>({ open: () => undefined, available: false });

export const useGargi = () => useContext(GargiContext);
